"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var FooterTextField = props => {
  var classes = (0, _styles.default)(props);
  return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    InputLabelProps: {
      classes: {
        root: classes.inputLabelRoot,
        focused: classes.inputLabelFocused
      },
      shrink: true
    },
    InputProps: {
      classes: {
        input: classes.input,
        root: classes.inputRoot,
        focused: classes.inputRootFocused,
        disabled: classes.inputRootDisabled,
        error: classes.inputError
      },
      disableUnderline: true
    }
  }, props));
};
var _default = exports.default = FooterTextField;